import { configureStore } from '@reduxjs/toolkit';
import { createBugReporterMiddleware } from '@clareefai/utils';
import { vendorApi } from './vendorApi';
import { promoterApi } from './promoterApi';
import { prospectApi } from './prospectApi';
import { meetingApi } from './meetingApi';
import { rewardApi } from './rewardApi';
import { teamMemberApi } from './teamMemberApi';
import { emailTemplateApi } from './emailTemplateApi';
import { notificationApi } from './notificationApi';
import { surveyApi } from './surveyApi';
import { teamMemberEmailIntegrationApi } from './teamMemberEmailIntegrationApi';
import { trialPublicApi, trialApi } from './trialApi';
import { mcpOAuthApi } from './mcpOAuthApi';
import { mcpApi } from './mcpApi';

export const store = configureStore({
  reducer: {
    [vendorApi.reducerPath]: vendorApi.reducer,
    [promoterApi.reducerPath]: promoterApi.reducer,
    [prospectApi.reducerPath]: prospectApi.reducer,
    [meetingApi.reducerPath]: meetingApi.reducer,
    [rewardApi.reducerPath]: rewardApi.reducer,
    [teamMemberApi.reducerPath]: teamMemberApi.reducer,
    [emailTemplateApi.reducerPath]: emailTemplateApi.reducer,
    [notificationApi.reducerPath]: notificationApi.reducer,
    [surveyApi.reducerPath]: surveyApi.reducer,
    [teamMemberEmailIntegrationApi.reducerPath]: teamMemberEmailIntegrationApi.reducer,
    [trialPublicApi.reducerPath]: trialPublicApi.reducer,
    [trialApi.reducerPath]: trialApi.reducer,
    [mcpOAuthApi.reducerPath]: mcpOAuthApi.reducer,
    [mcpApi.reducerPath]: mcpApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      vendorApi.middleware,
      promoterApi.middleware,
      prospectApi.middleware,
      meetingApi.middleware,
      rewardApi.middleware,
      teamMemberApi.middleware,
      emailTemplateApi.middleware,
      notificationApi.middleware,
      surveyApi.middleware,
      teamMemberEmailIntegrationApi.middleware,
      trialPublicApi.middleware,
      trialApi.middleware,
      mcpOAuthApi.middleware,
      mcpApi.middleware,
      createBugReporterMiddleware()
    ),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

